import React, { useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './HomeHero.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
function HomeHero() {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/sliders/public`);
        const data = await res.json();
        const formattedSlides = data.map(s => ({
          type: s.type,
          src: `${API_BASE_URL}${s.src}`,
          heading: s.heading || "",
          subText: s.subText || ""
        }));
        setSlides(formattedSlides);
      } catch (error) {
        console.error("Failed to load slides", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSlides();
  }, []);

   const length = slides.length;
  // Auto-slide every 6 seconds
  useEffect(() => {
  if (slides.length > 0) {
    const autoPlay = setInterval(() => {
      setCurrent(prev => (prev === length - 1 ? 0 : prev + 1));
    }, 6000);

    return () => clearInterval(autoPlay);
  }
}, [slides, length]);



  const nextSlide = () => {
  setCurrent(prev => (prev === length - 1 ? 0 : prev + 1));
};
 const prevSlide = () => {
  setCurrent(prev => (prev === 0 ? length - 1 : prev - 1));
};

  if (loading || !slides.length) return null;

  const currentSlide = slides[current];
  const hasHeading = !!currentSlide.heading;
  const hasSubText = !!currentSlide.subText;

  return (
    <section className="hero-modern-section">
      {/* --- Background Media Slides --- */}
      {slides.map((slide, index) => (
        <div className={`hero-item ${index === current ? 'active' : ''}`} key={index}>
          <div className="hero-media-wrapper">
            <div className="hero-vignette-overlay"></div>
            {slide.type === 'video' ? (
              <video className="hero-media-element" autoPlay loop muted playsInline>
                <source src={slide.src} type="video/mp4" />
              </video>
            ) : (
              <img src={slide.src} alt="College Banner" className="hero-media-element" />
            )}
          </div>
        </div>
      ))}

      {/* --- Dynamic Content Alignment --- */}
      <div className="hero-main-content">
        <div 
          className={`hero-text-area ${!hasHeading ? 'only-subtext' : ''} ${!hasSubText ? 'only-heading' : ''}`}
          key={current}
        >
          {hasHeading && <h1 className="hero-main-title">{currentSlide.heading}</h1>}
          
          {hasHeading && hasSubText && <div className="hero-gold-divider"></div>}
          
          {hasSubText && <p className="hero-description">{currentSlide.subText}</p>}
        </div>
      </div>

      {/* --- Navigation --- */}
      {length > 1 && (
        <>
          <div className="hero-side-controls">
            <button className="hero-nav-btn" onClick={prevSlide}><FaChevronLeft /></button>
            <button className="hero-nav-btn" onClick={nextSlide}><FaChevronRight /></button>
          </div>

          <div className="hero-indicator-bar">
            {slides.map((_, i) => (
              <div 
                key={i} 
                className={`indicator-segment ${i === current ? 'active' : ''}`}
                onClick={() => setCurrent(i)}
              />
            ))}
          </div>
        </>
      )}
    </section>
  );
}

export default HomeHero;